function Table({ columnNames, rowValues }) {
  return (
    <div className="overflow-x-auto text-left">
      <table className="min-w-full table-auto bg-white border-collapse border border-gray-200">
        <thead>
          <tr className="bg-gray-100">
            {columnNames.map((columnName) => (
              <th
                key={columnName}
                className="px-6 py-3 text-sm font-semibold text-left text-gray-700 uppercase border-b border-gray-200"
              >
                {columnName}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(rowValues).map(([key, value], index) => (
            <tr
              key={key}
              className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
            >
              <th className="px-6 py-2 text-sm font-medium text-gray-800 border-b border-gray-200">
                {key}
              </th>
              <td className="px-6 py-2 text-sm text-gray-600 border-b border-gray-200">
                {value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
